// extracted by mini-css-extract-plugin
export default {"section":"Section_section__-o4w7","sectionTitle":"Section_sectionTitle__MAKDv"};